import { useTranslation } from 'react-i18next';
import RentTutorialStriemoKey from '../components/RentTutorialStriemoKey';

export default function RentTutorial() {
  const { t } = useTranslation();
    return (
      <div>
        <h2>{t('Rental guide page')}</h2>
        <RentTutorialStriemoKey />
      </div>
    );
  }